// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VbdY","title":"styles_title__k9MOl"};